
<div class="basic-link">
  <!-- location -->
  <a v-if="href" :href="href"><slot /></a>

  <a v-else @click="$emit('click')"><slot /></a>
</div>
